import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearAuth } from "../Redux/authSlice";
import { TiHome } from "react-icons/ti";
import { IoCalendar, IoChatbubbleEllipsesOutline, IoChatbubblesOutline, IoPerson, IoPersonRemoveOutline, IoTicket } from "react-icons/io5";
import { BsCalendarEvent } from "react-icons/bs";
//import { MdOutlinePeopleAlt } from "react-icons/md";
import { AiOutlineLogout } from "react-icons/ai";
//import { FaRegHandshake } from "react-icons/fa";
import { MdAddCircle, MdWorkspacePremium } from "react-icons/md";

const Sidebar = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 840);
  const [photoProfil, setPhotoProfil] = useState(null);
  const [nomComplet, setNomComplet] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 840);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ── Charge la photo du créateur (sauvegardée au login/inscription) ─
  useEffect(() => {
    const photo = localStorage.getItem("photo_profil") || sessionStorage.getItem("photo_profil");
    const nom = localStorage.getItem("nomComplet") || sessionStorage.getItem("nomComplet");
    if (photo) setPhotoProfil(photo);
    if (nom) setNomComplet(nom);
  }, []);

  const handleClick = (path) => {
    navigate(path);
    if (isMobile) document.body.classList.remove("overflow-hidden");
  };

  const handleLogout = () => {
    dispatch(clearAuth());
    navigate("/login");
  };

  const menuItems = [
    { label: "Ajouter Évent", icon: MdAddCircle, path: "/EspaceClient/mesevents/ajouter" },
    { label: "Dashboard", icon: TiHome, path: "/EspaceClient" },
    //{ label: "Utilisateurs", icon: MdOutlinePeopleAlt, path: "/EspaceClient/utilisateurs" },
    { label: "Mes Événts", icon: BsCalendarEvent, path: "/EspaceClient/mesevents" },
    //{ label: "Abonnements", icon: BsCreditCard, path: "/EspaceClient/abonnements" },
    { label: "Mon Équipes", icon: IoPerson, path: "/EspaceClient/monequipes" },
    { label: "Agenda", icon: IoCalendar, path: "/EspaceClient/agenda" },
    { label: "Ma Billetterie", icon: IoTicket, path: "/EspaceClient/mabilletterie" },
    { label: "Communauté", icon: IoChatbubblesOutline, path: "/EspaceClient/communaute" },
    { label: "Messagerie", icon: IoChatbubbleEllipsesOutline, path: "/EspaceClient/messagerie" },
    //{ label: "Abonnement", icon: MdWorkspacePremium, path: "/EspaceClient/abonnement" },
    { label: "Profil", icon: IoPerson, path: "/EspaceClient/profil" },

    //{ label: "Sponsoriser", icon: FaRegHandshake, path: "/EspaceClient/sponsoriser" },
  ];
  // ✅ Dashboard sélectionné par défaut
  const isActive = (path) => {
    // Si on est sur la racine du dashboard, on considère Dashboard comme actif
    if (location.pathname === "/EspaceClient" && path === "/EspaceClient/dashboard") return true;
    return location.pathname === path;
  };

  return (
    <div className="relative">
      {!isMobile && (
        <div className="fixed top-0 left-0 flex flex-col h-screen
         bg-color4 text-color2 px-0 py-6 overflow-hidden scrollbar-thin
          scrollbar-thumb-black scrollbar-track-gray-900 rounded-r-lg border-r-2 border-color4">

          {/* Photo du créateur connecté (fallback : logo si pas encore chargée) */}
          <div
            className="flex flex-col items-center cursor-pointer justify-center gap-2 pb-2"
            onClick={() => navigate("/EspaceClient/profil")}
          >
            <img
              src={photoProfil || require("../assets/logo.png")}
              alt={nomComplet || "Profil"}
              className="h-20 w-20 object-cover rounded-full border-2 border-color1"
              onError={(e) => { e.currentTarget.src = require("../assets/logo.png"); }}
            />

          </div>

          {/* Menu principal */}
          <div className="flex-1 flex flex-col gap-2 overflow-y-auto">
            {menuItems.map((item) => {
              const active = isActive(item.path);
              return (
                <button
                  key={item.label}
                  onClick={() => handleClick(item.path)}
                  className={`flex flex-row items-center gap-4 px-5 py-2 
                    w-full font-bold text-base font-Poppins transition-all
                    ${active
                      ? "  text-color2 bg-color1 rounded-md"
                      : "border-l-0 text-color2 hover:bg-color6 rounded-md "
                    }`}
                >
                  <item.icon
                    size={20}
                    className={active ? "text-color2" : "text-color2"}
                  />
                  <p>{item.label}</p>
                </button>
              );
            })}
          </div>

          {/* Bouton déconnexion */}
          <div className="flex flex-col gap-2 mt-4 border-t border-color2/20 pt-4">
            <button
              onClick={handleLogout}
              className="flex flex-row items-center gap-4 px-5 py-2 w-full font-bold text-base font-Poppins text-color2 hover:text-red-500 transition-colors"
            >
              <AiOutlineLogout size={20} />
              <p>Se déconnecter</p>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Sidebar;